import {
  portfolioOverviewIcon,
  portfolioOverviewIconSelected,
} from '../assets/fontawesome/portfolioOverviewIcons'

import {
  metricsIcon,
  metricsIconSelected,
} from '../assets/fontawesome/metricsIcons'

// import {
//   analysisIcon,
//   analysisIconSelected,
// } from '../../src/assets/fontawesome/analysisIcons'

import {
  historyIcon,
  historyIconSelected,
} from '../assets/fontawesome/historyIcons'

import {
  qualityMonitoringIcon,
  qualityMonitoringIconSelected,
} from '../assets/fontawesome/qualityMonitoring'
import {
  latestForecastIcon,
  latestForecastIconSelected,
} from '../assets/fontawesome/latestIcon'
import {
  performanceCompareIcon,
  performanceCompareIconSelected,
} from '../assets/fontawesome/performanceCompareIcons'
import {
  conwxPortfolioIcon,
  conwxPortfolioIconSelected,
} from '../assets/fontawesome/conwxPortfolioIcons'
import {
  powerCurveIcon,
  powerCurveIconSelected,
} from '../assets/fontawesome/powerCurveIcons'

export const modules = {
  overview: {
    id: 'overview',
    url: '/overview',
    name: 'Portfolio Overview',
    title: 'Portfolio Overview',
    description: 'For all users',
    icon: {
      default: portfolioOverviewIcon,
      selected: portfolioOverviewIconSelected,
    },
    route: 1,
  },
  history: {
    id: 'history',
    url: '/history',
    name: 'Portfolio History',
    title: 'Portfolio History',
    description: 'For all users',
    icon: {
      default: historyIcon,
      selected: historyIconSelected,
    },
    route: 2,
  },
  metrics: {
    id: 'metrics',
    url: '/metrics',
    name: 'Metrics',
    title: 'Metrics',
    description: 'For all users',
    icon: {
      default: metricsIcon,
      selected: metricsIconSelected,
    },
    route: 3,
  },
  // analysis: {
  //   id: 'analysis',
  //   url: '/analysis',
  //   name: 'Analysis',
  //   title: 'Analysis',
  //   icon: {
  //     default: analysisIcon,
  //     selected: analysisIconSelected,
  //   },
  //   route: 4,
  // },
  monitoring: {
    id: 'monitoring',
    url: '/monitoring',
    name: 'Quality Monitoring',
    title: 'Quality Monitoring',
    description: 'For internal usage',
    icon: {
      default: qualityMonitoringIcon,
      selected: qualityMonitoringIconSelected,
    },
    route: 5,
  },
  latest: {
    id: 'latest',
    url: '/latest',
    name: 'Latest Forecast',
    title: 'Latest Forecast',
    description: 'For internal usage',
    icon: {
      default: latestForecastIcon,
      selected: latestForecastIconSelected,
    },
    route: 6,
  },
  comparison: {
    id: 'comparison',
    url: '/comparison',
    name: 'Performance Comparison',
    title: 'Performance Comparison',
    description: 'For internal usage',
    icon: {
      default: performanceCompareIcon,
      selected: performanceCompareIconSelected,
    },
    route: 7,
  },

  conwx_portfolio: {
    id: 'conwx_portfolio',
    url: '/conwx_portfolio',
    name: 'ConWX Portfolio',
    title: 'ConWX Portfolio',
    description: 'For internal usage',
    icon: {
      default: conwxPortfolioIcon,
      selected: conwxPortfolioIconSelected,
    },
    route: 8,
  },

  power_curve: {
    id: 'power_curve',
    url: '/power_curve',
    name: 'Power Curve Overview',
    title: 'Power Curve Overview',
    description: 'For internal usage',
    icon: {
      default: powerCurveIcon,
      selected: powerCurveIconSelected,
    },
    route: 9, // fills the gap left by the commented-out analysis module
  },
  settings: {
    id: 'settings',
    url: '/settings',
    name: 'Settings',
    title: 'Settings',
    description: 'For internal usage',
    route: 50,
  },
  wiki: {
    id: 'wiki',
    url: '/wiki',
    name: 'Wiki',
    title: 'Wiki',
    description: 'For all users',
    route: 60,
  },
}

export const moduleIsAvailable = (moduleId, availableModules) => {
  return availableModules.includes(moduleId)
}

export const getModulePermissions = () => {
  const moduleList = []
  for (const moduleId in modules) {
    // wiki module will be available for any user
    if (moduleId !== 'wiki') {
      const capitalizedId = moduleId.charAt(0).toUpperCase() + moduleId.slice(1)
      moduleList.push(capitalizedId)
    }
  }
  return moduleList
}

export default getModulePermissions
